import React from 'react';

import icons from '../imagesPillarPages';
import LandingPageInfoBox from '../LandingPages/LandingPageInfoBox';

export default ({ reference, click }) => {
  return (
    <div className="container  my-5">
      <div className="row">
        <div className="col">
          <h2 className="subtitle bigger">Joining us also means</h2>
          <div className="content">
            <p>
              In addition to a warm welcome from the whole team, you will also
              get these perks.
            </p>
          </div>
        </div>
      </div>
      <div className="work-with d-flex flex-column flex-md-row justify-content-between">
        <LandingPageInfoBox
          smIcon
          icon={icons.checkmarkSVG}
          title="Flexible hours"
          description="For the perfect work/life balance that fits you."
        />
        <LandingPageInfoBox
          smIcon
          icon={icons.checkmarkSVG}
          title="Hardware"
          description="That is at the TOP of its class."
        />
        <LandingPageInfoBox
          smIcon
          icon={icons.checkmarkSVG}
          title="Learning and development"
          description="Internal and external conferences, meetups and courses for your professional development."
        />
      </div>
      <div className="work-with d-flex flex-column flex-md-row justify-content-between">
        <LandingPageInfoBox
          smIcon
          icon={icons.checkmarkSVG}
          title="Private health care package"
          description="Your well-being is important, so we co-finance your medical plan"
        />
        <LandingPageInfoBox
          smIcon
          icon={icons.checkmarkSVG}
          title="Remote work possibility"
          description="You can work remotely, from our office, or in a hybrid model! We are flexible"
        />
        <LandingPageInfoBox
          smIcon
          icon={icons.checkmarkSVG}
          title="Fun"
          description="We have a budget for going out and getting to know each other."
        />
      </div>
      <button
        ref={reference}
        onClick={click}
        type="button"
        bg="#EAEBF1"
        className="btn btn-main narrow fill mt-2 mt-md-5  mx-auto mx-md-0"
      >
        See open positions
      </button>
    </div>
  );
};
